import React, { useEffect, useState } from 'react';
import { useSpring, animated, config } from 'react-spring';
import '../styles.css';
import { connect, useSelector } from 'react-redux';
import { selectSize, setOptions, setOver, updateStats } from '../REDUX/actions';
import { goToPage, forceUpdate } from '../../HOME/REDUX/actions';
import { OPTIONS_KEY, HELPED_KEY, RE_RED, RE_GREEN, RE_BLUE, RE_NAVY, RE_YELLOW, RE_PURPLE } from '../const';
import BackButton from '../COMPONENTS/BackButton';
import { NoGradientBackground } from '../COMPONENTS/Background';
import Logo from '../ASSETS/RokuEnLogoTransparent.png';
import { windowSize, delay, dbget } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import { HELP_PAGE, GAME_PAGE, START_PAGE } from '../../HOME/const';
import { isNum } from '../../HOME/utils';
import Card from '../COMPONENTS/Card';
import Title from '../ASSETS/RokuEnTitle.png';
import * as f from '../logic';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

const StartPage = props => {
  const { setOptions, forceUpdate } = props;
  const { re } = useSelector(state => state);

  useEffect(() => {
    window.addEventListener('resize', forceUpdate);

    dbget(OPTIONS_KEY, options => setOptions(options));

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [setOptions, forceUpdate]);

  const getGridArea = op => {
    switch (op) {
      default:
        return '1/1';
      case 1:
        return '1/2';
      case 2:
        return '1/3';
      case 3:
        return '2/1';
      case 4:
        return '2/2';
      case 5:
        return '2/3';
    }
  };

  const handleSize = size => {
    setSize(size);
  };

  const doHandleSize = () => {
    if (!size) {
      props.goToPage(HELP_PAGE, START_PAGE);
      return;
    }

    props.selectSize(size);

    f.getStats({ size }, stats => {
      props.updateStats(stats);
    });

    dbget(HELPED_KEY, response => {
      if (response || re.helped) {
        props.setOver(false);
        props.goToPage(GAME_PAGE);
      } else {
        props.goToPage(HELP_PAGE, START_PAGE);
      }
    });
  };

  const { x, y } = windowSize();
  const width = Math.min(x, y) / 7;
  const [size, setSize] = useState(null);

  const flipSpring = useSpring({
    transform: `rotate${_.random(1) ? 'X' : 'Y'}(${isNum(size) ? 360 : 0}deg)`,
    onStart: () => {
      if (isNum(size)) {
        delay(doHandleSize, 400);
      }
    },
    config: config.fast,
  });

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <img src={Logo} width={width} alt="Roku-En logo" />
        <img src={Title} height={(width * 7) / 9} alt="roku-en" />
      </div>
      <div className="re-page" style={{ backgroundImage: NoGradientBackground }}>
        <div style={{ display: 'grid', grid: 'auto auto / auto auto auto auto' }}>
          {_.map([0, 1, 2, 3, 4, 5], op => {
            const gridArea = getGridArea(op);
            const style = op === size ? flipSpring : {};
            return (
              <animated.div key={op} style={{ ...style, gridArea, margin: '2px', cursor: 'pointer' }} onClick={() => handleSize(op)}>
                {op === 0 && <Card card={{ question: true }} />}
                {op === 1 && <Card card={{ yens: [{ area: '1/1', color: RE_RED }, { area: '3/2', color: RE_BLUE }] }} X />}
                {op === 2 && (
                  <Card
                    card={{
                      yens: [{ area: '1/2', color: RE_NAVY }, { area: '2/1', color: RE_GREEN }, { area: '3/1', color: RE_YELLOW }],
                    }}
                  />
                )}
                {op === 3 && (
                  <Card
                    card={{
                      yens: [
                        { area: '1/1', color: RE_RED },
                        { area: '1/2', color: RE_NAVY },
                        { area: '2/1', color: RE_GREEN },
                        { area: '3/2', color: RE_BLUE },
                      ],
                    }}
                  />
                )}
                {op === 4 && (
                  <Card
                    card={{
                      yens: [
                        { area: '1/1', color: RE_RED },
                        { area: '1/2', color: RE_NAVY },
                        { area: '2/1', color: RE_GREEN },
                        { area: '2/2', color: RE_PURPLE },
                        { area: '3/1', color: RE_YELLOW },
                      ],
                    }}
                  />
                )}
                {op === 5 && (
                  <Card
                    card={{
                      yens: [
                        { area: '1/1', color: RE_RED },
                        { area: '1/2', color: RE_NAVY },
                        { area: '2/1', color: RE_GREEN },
                        { area: '2/2', color: RE_PURPLE },
                        { area: '3/1', color: RE_YELLOW },
                        { area: '3/2', color: RE_BLUE },
                      ],
                    }}
                  />
                )}
              </animated.div>
            );
          })}
        </div>
        <BmgButton />
        <BackButton />
        <HomeButton color="black" />
      </div>
    </div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  { selectSize, goToPage, setOptions, setOver, forceUpdate, updateStats }
)(StartPage);
